import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getRideNotes } from '../api/services/Rides';
import { RideNotes } from '../types/rides';

interface iUseRideNotesQuery {
  rideSlug: string;
}

export const RIDE_NOTES_QUERY_KEY = 'rideNotes';

export const useRideNotesQuery = ({ rideSlug }: iUseRideNotesQuery) => {
  return useApiGet<{ data: RideNotes[] }>([RIDE_NOTES_QUERY_KEY, rideSlug], () => getRideNotes(rideSlug), {
    enabled: true,
  });
};
